import Product from "onnit-ui/lib/@types/interfaces/product/BuyBoxProduct";
import Text, { Sup } from "onnit-ui/lib/text";
import React from "react";
import { TrialProduct } from "../trials";
import { TrialDisclaimerText as AlphaBrainDisclaimer } from "../../alpha-brain-trial/Page";
import { TrialDisclaimerText as TotalHumanDisclaimer } from "../../total-human-trial/Page";

interface DisclaimerProps {
    fullProduct: Product;
    activeTrialProduct: TrialProduct;
}

export const Disclaimer: React.FC<DisclaimerProps> = ({ fullProduct, activeTrialProduct }) => {
    const disclaimerColor = "grays.4";
    switch (activeTrialProduct) {
        case TrialProduct.AlphaBrain:
            return (<AlphaBrainDisclaimer product={fullProduct} color={disclaimerColor} />);
        case TrialProduct.TotalHuman:
            return (<TotalHumanDisclaimer product={fullProduct} color={disclaimerColor} />);
        case TrialProduct.NewMood:
            return (<NewMoodTrialDisclaimerText product={fullProduct} color={disclaimerColor} />);
        case TrialProduct.ShroomTechSport:
            return (<ShroomTechSportTrialDisclaimerText product={fullProduct} color={disclaimerColor} />);
    }
    return (<></>);
};

function NewMoodTrialDisclaimerText({ product, color = "grays.5" }: { product: Product, color?: string }) {

    const calculatePrice = (priceMsrp: string) => {
        const price = parseFloat(priceMsrp);
        return price - (price * 0.15);
    };

    return (
        <>
            <Text fontSize={0} lineHeight={6} color={color} mb={4}>
                Customers signing up will receive a free 30-Count bottle (15-day supply), and we’ll send it for just the cost of shipping and tax.
            </Text>
            <Text fontSize={0} lineHeight={6} color={color} mb={4}>
                This free trial purchase includes a subscription that autoships New MOOD<Sup variant="reg" /> 30-Count 30 days after the initial order is placed,
                and then every 15 days thereafter at 15% off MSRP (${calculatePrice(product.price_msrp_raw).toFixed(2)}) + shipping & tax.
            </Text>
            <Text fontSize={0} lineHeight={6} color={color} mb={4}>
                Cancel the subscription any time within the first 30 days of ordering and we won’t send any additional product - it’s really that simple! Should the subscription remain active and
                recurring orders process but you do not wish to keep your subscription active, unopened product can be returned for a refund within 90 days and your subscription can be cancelled.
            </Text>
            <Text fontSize={0} lineHeight={6} color={color}>
                <a href="/terms-and-conditions/subscription/" target="_blank">
                    Read more details about our subscription program <span style={{ fontWeight: "bold" }}>here</span>.
                </a>
            </Text>
        </>
    );
}

function ShroomTechSportTrialDisclaimerText({ product, color = "grays.5" }: { product: Product, color?: string }) {

    const calculatePrice = (priceMsrp: string) => {
        const price = parseFloat(priceMsrp);
        return price - (price * 0.15);
    };

    return (
        <>
            <Text fontSize={0} lineHeight={6} color={color} mb={4}>
                Customers signing up will receive a free 28-count bottle (7-day supply), and we’ll send it for just the cost of shipping and tax.
            </Text>
            <Text fontSize={0} lineHeight={6} color={color} mb={4}>
                This free trial purchase includes a subscription that autoships Shroom Tech® SPORT 28-Count 30 days after the initial order is placed, and then every 15 days
                thereafter at 15% off MSRP (${calculatePrice(product.price_msrp_raw).toFixed(2)}) + shipping & tax.
            </Text>
            <Text fontSize={0} lineHeight={6} color={color} mb={4}>
                Cancel the subscription any time within the first 30 days of ordering and we won’t send any additional product - it’s really that simple! Should the subscription remain active and
                recurring orders process but you do not wish to keep your subscription active, unopened product can be returned for a refund within 90 days and your subscription can be cancelled.
            </Text>
            <Text fontSize={0} lineHeight={6} color={color}>
                <a href="/terms-and-conditions/subscription/" target="_blank">
                    Read more details about our subscription program <span  style={{ fontWeight: "bold" }}>here</span>.
                </a>
            </Text>
        </>
    );
}